import React, { useState } from 'react';
import { ReactComponent as HandIcon } from 'assets/icons/hand-icon.svg';
import { Link } from 'react-router-dom';
import { PostType } from 'models/posts.model';
import { handleApiError, isPostActive } from 'utils/functions';
import {
  Dropdown,
  DropdownItem,
  DropdownList,
  Switch,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import { ReactComponent as VerticalDotsIcon } from 'assets/icons/vertical-dots.svg';
import DuplicatePostModal from 'components/modals/duplicate-post';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import DeletePostModal from 'components/modals/delete-post-modal';

const PostCard = ({ post, handleDelete }: { post: PostType; handleDelete: () => void }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showCokitchenModal, setShowCokitchenModal] = useState(false);
  const [showDeletePostModal, setShowDeletePostModal] = useState(false);
  const [isActive, setIsActive] = useState(post.active);
  const imgSrc =
    Array.isArray(post.images) && post.images.length
      ? post.images[0]
      : typeof post.images === 'string' && JSON.parse(post.images)?.[0];
  const active = isPostActive(post);

  const toggleActiveState = async (newState: boolean) => {
    try {
      const res = await apiService.patch(`marketing/home-page-posts/${post.id}/toggle`);
      toast(<ToastMessage type='success' message={res.data?.message} />);
      setIsActive(newState);
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <div className='rounded-lg bg-white shadow-md overflow-hidden'>
      {showCokitchenModal && (
        <DuplicatePostModal
          isOpen={showCokitchenModal}
          onClose={() => setShowCokitchenModal(false)}
          post={post}
        />
      )}
      {showDeletePostModal && (
        <DeletePostModal
          isOpen={showDeletePostModal}
          onClose={() => setShowDeletePostModal(false)}
          id={post.id}
          title={post.title}
          handleDelete={handleDelete}
        />
      )}
      <div className='relative group'>
        <Switch
          active={isActive}
          onChange={(value) => toggleActiveState(value)}
          className='absolute opacity-20 group-hover:opacity-100 top-2 right-2'
        />
        <img src={imgSrc || ''} alt='' className='w-full aspect-video object-cover max-h-[127px]' />
      </div>
      <div className='flex flex-col gap-3 px-4 py-3'>
        <div className='flex justify-between items-center'>
          <div>
            <h4 className='font-medium text-sm text-gray-6 mb-1'>{post.heading}</h4>
            <p className='text-xs text-gray-8'>{post.title}</p>
          </div>
          <span
            className={`${
              active
                ? 'text-green-5 border-green-3 bg-green-8'
                : 'text-[#B26800] border-[#B26800] bg-[#B26800]/10'
            } text-xs py-[2px] px-[10px] border rounded-[40px] `}>
            {active ? 'Active' : 'Inactive'}
          </span>
        </div>
        <div className='flex items-center justify-between'>
          <div className='flex items-start gap-[6px]'>
            <HandIcon />
            <p className='text-xs text-gray-5'>5,000</p>
          </div>
          <Dropdown
            visible={showDropdown}
            onClickOutside={() => setShowDropdown(false)}
            content={
              <VerticalDotsIcon
                className='w-4 h-4  text-gray-6 cursor-pointer'
                onClick={() => setShowDropdown(true)}
              />
            }>
            <DropdownList className='drop-shadow-lg !w-24  text-gray-6 font-medium block'>
              <DropdownItem
                className='text-xs'
                onClick={() => {
                  setShowDropdown(false);
                  setShowCokitchenModal(true);
                }}>
                Duplicate Post
              </DropdownItem>
              <Link to={`/posts/${post.id}/edit`}>
                <DropdownItem className='text-xs'>Edit Post</DropdownItem>
              </Link>

              <DropdownItem
                className='text-xs text-red-5'
                onClick={() => {
                  setShowDropdown(false);
                  setShowDeletePostModal(true);
                }}>
                Delete Post
              </DropdownItem>
            </DropdownList>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
